import CheckIcon from '@mui/icons-material/Check';

const Skill= ({ label }) => (
  <div className="flex items-center ml-4 mt-4">
    <CheckIcon className="text-amarillo" sx={{ fontSize: 18 }} />
    <p className="text-xs text-main ml-2">{label}</p>
  </div>
);

export default Skill;
